import { BubbleMenu as BaseBubbleMenu } from '@tiptap/react'
import React, { useCallback, useState } from 'react'
import { sticky } from 'tippy.js'
import { v4 as uuid } from 'uuid'

import { MenuProps } from '../../../features/menus/types.js'
import { Toolbar } from '../../../features/ui/Toolbar.js'
import i18next from 'i18next'
import { LinkPreviewEditorPanel } from '../LinkPreviewEditorPanel.js'
import { FetchSiteMetadataType } from 'src/fields/TiptapEditor/features/BlockEditor/types.jsx'

export const ILinkPreviewMenu = ({
  editor,
  appendTo,
  fetchSiteMetadata,
}: MenuProps & { fetchSiteMetadata: FetchSiteMetadataType }) => {
  const [isLoading, setIsLoading] = useState(false)

  const shouldShow = useCallback(() => {
    const isLinkPreview = editor.isActive('linkPreview')
    return isLinkPreview
  }, [editor])

  const onSetLink = useCallback(
    async (src: string) => {
      if (fetchSiteMetadata) {
        try {
          setIsLoading(true)
          const metadata = await fetchSiteMetadata(src)
          editor.chain().focus().setLinkPreview(src, metadata).blur().setTextSelection(0).run()
        } catch (error) {
          console.error('Error fetching site metadata:', error)
        } finally {
          setIsLoading(false)
        }
      }
    },
    [editor, fetchSiteMetadata],
  )

  return (
    <BaseBubbleMenu
      editor={editor}
      pluginKey="linkPreview"
      shouldShow={shouldShow}
      tippyOptions={{ popperOptions: { placement: 'top-start' } }}
      updateDelay={100}
    >
      <Toolbar.Button type="button">
        <LinkPreviewEditorPanel
          onSetLink={onSetLink}
          isLoading={isLoading}
          // @ts-ignore
          initialSrcLink={editor?.getAttributes('linkPreview')?.editorValue ?? ''}
        />
      </Toolbar.Button>
    </BaseBubbleMenu>
  )
}

export default ILinkPreviewMenu
